import { z } from "zod";

export const getFromIdPayloadSchema = z.object({
  id: z.string().uuid()
}).strip();
export type getFromIdPayload = z.infer<typeof getFromIdPayloadSchema>;

export const getFromMaterialIdPayloadSchema = z.object({
  id: z.number(),
}).strip();
export type getFromMaterialIDPayload = z.infer<typeof getFromMaterialIdPayloadSchema>;

export const getFromNamePayloadSchema = z.object({
  name: z.string(),
}).strip();
export type getFromNamePayload = z.infer<typeof getFromNamePayloadSchema>;

export const setDeletePayloadSchema = z.object({
  id: z.string().uuid(),
  deleted: z.boolean(),
}).strip();
export type setDeletePayload = z.infer<typeof setDeletePayloadSchema>;